// extracted by mini-css-extract-plugin
export default {"label":"SuperCheckbox_label__gAhY2","checkbox":"SuperCheckbox_checkbox__JvQco","spanClassName":"SuperCheckbox_spanClassName__mme+C"};